import { SpaceBetween } from "@cloudscape-design/components-themed";
import { RegisterInfo } from "../components/gw-contract-register/RegisterInfo";
import { USER_TYPE, PERMISSIONS } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const GwContractsRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.GW);
  // 事業者種別取得
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  return (
    <SpaceBetween size="l">{isDocomoUser && <RegisterInfo />}</SpaceBetween>
  );
};

export default GwContractsRegister;
